module.exports = __webpack_public_path__ + "img/branch-particle-07.f48dd002.png";